import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, Skeleton } from "@mui/material";
import ReactPaginate from "react-paginate";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { Link, useNavigate } from "react-router-dom";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import EditProduct from "./EditProduct";
import DeleteModal from "../../../constants/DeleteModal";
import { usePermission } from "../../../context/PermissionContext";
import ProductOverView from "./ProductOverView";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import Table from "../../../constants/Table";
import BarcodeGenerator from "./BarCode";
import uRLs from "../../../utils/baseUtils";
import { toPrimaryQuantity } from "@heartinz/finance";
import ProductSearchList from "../../../constants/ProductSearchList";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import {
  AddIcon,
  BarcodeIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  RefreshIcon,
  SearchIcon,
  SortDownIcon,
  SpreadSheetIcon,
  UploadIcon,
  XIcon,
} from "../../../constants/Icons";

const AllListProduct = ({ isActive }) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const hasFetched = useRef(false);
  const containerRef = useRef(null);
  const [isProductData, setProductData] = useState([]);
  const [noteSuggest, setNoteSuggest] = useState([]);
  const searchInputRef = useRef(null);
  const ProductSuggestionsRef = useRef(null);
  const { permission, hasPermission, globelPopupOpen } = usePermission();
  const [brandSuggest, setBrandSuggest] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(10);
  const suggestionRefs = useRef([]);

  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const [productViewOpen, setProductViewOpen] = useState(false);
  const [productData, setPrductData] = useState([]);
  const [productStockData, setPrductStockData] = useState([]);
  const [isSearchTerm, setSearchTerm] = useState("");
  const [ProductSuggestions, setProductSuggestions] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState("");
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isDeleteData, setDeleteData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const [isBtnCSVLoading, setBtnCSVLoading] = useState(false);

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const navigate = useNavigate();

  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const primaryQuanity = (quanity, unitData) => {
    const qty = toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  };

  const handleOpenProductView = async (product) => {
    setPrductData(product);
    await handleStockDetails(product);
    setProductViewOpen(true);
  };
  const handleStockDetails = async (product) => {
    try {
      if (!checkNetwork()) return;
      const data = { productid: product._id };
      const response = await AxiosInstance.get(
        `module/stock/primary-store/${product._id}`,
      );
      const products = response.data?.results;
      setPrductStockData(products);
      // if (products.length > 0) {
      //   setStockModalOpen(true);
      //   matchOpen(true);
      //   setStockData(products);

      //   setSearchTerm("");
      //   setProductSugesstions([]);
      //   searchOpen(false);
      // } else {
      //   showAlert("warning", Messages.ERROR.NO_STOCK);
      // }
    } catch (error) {
      setPrductStockData();
      // handleError(error, showAlert);
    }
  };
  const handleCloseProductView = () => {
    setProductViewOpen(false);
  };

  const handleListProduct = async (page = 0, term = "", perPage = 10) => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      const data = { searchtxt: term, pageno: page + 1, perpage: perPage };
      const response = await AxiosInstance.get(
        `module/product/all?pageno=${
          page + 1
        }&limit=${perPage}&searchtxt=${term}&sortby=a-z`,
      );
      const results = response.data.results || [];
      setProductData(results);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (term) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:search") ||
      permission === undefined
    ) {
      setSearchTerm(term);
      setHasSearched(true);
      setSelectedProductCode("");

      if (!term.trim()) {
        setProductSuggestions([]);
        handleListProduct(0, "", selectedFilter);
        setCurrentPage(0);
        return;
      }
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      debounceTimerRef.current = setTimeout(async () => {
        try {
          if (!checkNetwork()) return;
          setSuggestionLoading(true);

          controllerRef.current = new AbortController();
          const currentId = ++requestIdRef.current;
          const response = await AxiosInstance.get(
            `module/product/search-hybrid-active?searchtxt=${term}`,
            { signal: controllerRef.current.signal },
          );
          if (currentId === requestIdRef.current) {
            setProductSuggestions(response.data.results || []);
          }
        } catch (error) {
          if (error.name !== "CanceledError" && error.name !== "AbortError") {
            handleError(error, showAlert);
          }
        } finally {
          setSuggestionLoading(false);
        }
      }, 200);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSearchFind = () => {
    const currentInputValue = searchInputRef.current?.value || "";
    setSearchTerm(currentInputValue);
    setSelectedProductCode(currentInputValue);
    if (!currentInputValue.trim()) {
      handleListProduct(0, "", selectedFilter);
    } else {
      handleListProduct(0, currentInputValue, selectedFilter);
    }
    setProductSuggestions([]);
    setHasSearched(false);
    setCurrentPage(0);
  };

  const handleSelectProduct = (product) => {
    const code = product.code;
    setSearchTerm(code);
    setSelectedProductCode(code);
    setProductSuggestions([]);
    setHasSearched(false);
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    handleListProduct(0, code, selectedFilter);
    setCurrentPage(0);
  };

  const handleOutsideClick = (e) => {
    if (
      ProductSuggestionsRef.current &&
      !ProductSuggestionsRef.current.contains(e.target)
    ) {
      setProductSuggestions([]);
      setHasSearched(false);
    }
  };

  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem.landingcost || 0,
          "INR",
        ),
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleUpdte = async (updatedData, imageFile, trigger = true) => {
    const original = isEditData || productData;
    const formData = new FormData();
    let isDataChanged = false;
    const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
      if (newVal !== oldVal) {
        formData.append(key, transform(newVal));
        isDataChanged = true;
      }
    };

    const isPriceGroupChanged =
      updatedData?.mrp !== original?.mrp ||
      updatedData?.saleprice !== original?.saleprice ||
      updatedData?.baseprice !== original?.baseprice ||
      updatedData?.taxpercentage !== original?.taxpercentage ||
      updatedData?.isLock !== original.isLock;

    if (isPriceGroupChanged) {
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
      );
      formData.append("taxpercentage", updatedData?.taxpercentage);
      formData.append("isLock", updatedData?.isLock);

      isDataChanged = true;
    }

    const newMin = CurrencyConverter.toSubunit(
      Number(updatedData?.minimumSalePrice || 0),
      "INR",
    );

    const oldMin =
      typeof original?.minimumSalePrice === "number"
        ? original.minimumSalePrice
        : CurrencyConverter.toSubunit(
            Number(original?.minimumSalePrice || 0),
            "INR",
          );

    if (newMin !== oldMin) {
      formData.append("minimumSalePrice", newMin);
      isDataChanged = true;
    }

    appendIfChanged("code", updatedData?.code, original?.code);
    appendIfChanged(
      "hsnsac",
      updatedData?.hsnsac ?? "",
      original?.hsnsac ?? "",
    );
    appendIfChanged("title", updatedData?.title, original?.title);
    // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
    // appendIfChanged("isLock", updatedData.isLock, original.isLock);
    appendIfChanged("shortName", updatedData?.shortName, original?.shortName);
    appendIfChanged("note", updatedData?.note, original?.note);
    appendIfChanged(
      "searchTag",
      updatedData?.searchTag ?? "",
      original?.searchTag ?? "",
    );
    appendIfChanged(
      "brandId",
      updatedData?.brandData?.title ?? "",
      original?.brandId ?? "",
    );
    // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    appendIfChanged(
      "landingcost",
      updatedData?.landingcost || 0,
      original?.landingcost || 0,
      (v) => CurrencyConverter.toSubunit(v, "INR"),
    );

    const newUnit = updatedData?.unitConfig;
    const oldUnit = original?.unitConfig;

    if (
      !updatedData?.unitLocked &&
      JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
    ) {
      formData.append("unitConfig", JSON.stringify(newUnit));
      isDataChanged = true;
    }
    if (imageFile instanceof File) {
      formData.append("primaryImage", imageFile);
      isDataChanged = true;
    }

    if (!isDataChanged) {
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      if (trigger) closeEditModal();
      return true;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.patch(
        `module/product/update-product/${updatedData?._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);

      setProductData((prev) =>
        prev.map((p) =>
          p._id === response.data.results?._id ? response.data.results : p,
        ),
      );

      if (trigger) closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  // const handleUpdte = async (updatedData, imageFile, trigger = true) => {

  //   const originalDataForComparison = isEditData;
  //   let isDataChanged = false;
  //   if (
  //     updatedData?.code !== originalDataForComparison?.code ||
  //     updatedData?.hsnsac !== originalDataForComparison?.hsnsac ||
  //     updatedData.title !== originalDataForComparison?.title ||
  //     updatedData.taxpercentage !== originalDataForComparison?.taxpercentage ||
  //     updatedData.isLock !== originalDataForComparison?.isLock ||
  //     updatedData?.note !== originalDataForComparison?.note ||
  //     updatedData?.searchTag !== originalDataForComparison?.searchTag ||
  //     updatedData?.brandData?.title!=originalDataForComparison?.brandId
  //   ) {
  //     isDataChanged = true;
  //   }

  //   if (
  //     !isDataChanged &&
  //     (updatedData?.mrp !== originalDataForComparison?.mrp ||
  //       updatedData?.saleprice !== originalDataForComparison?.saleprice ||
  //       updatedData?.baseprice !== originalDataForComparison?.baseprice ||
  //       updatedData?.landingcost !== originalDataForComparison?.landingcost)
  //   ) {
  //     isDataChanged = true;
  //   }
  //   if (
  //     !isDataChanged &&
  //     (
  //       updatedData?.unitConfig?.primaryUnitName !==
  //         originalDataForComparison?.unitConfig?.primaryUnitName ||
  //       updatedData?.unitConfig?.primaryUnitCode !==
  //         originalDataForComparison?.unitConfig?.primaryUnitCode ||
  //       updatedData?.unitConfig?.secondaryUnitName !==
  //         originalDataForComparison?.unitConfig?.secondaryUnitName ||
  //       updatedData?.unitConfig?.secondaryUnitCode !==
  //         originalDataForComparison?.unitConfig?.secondaryUnitCode ||
  //       updatedData?.unitConfig?.conversion !==
  //         originalDataForComparison?.unitConfig?.conversion
  //     )
  //   ) {
  //     isDataChanged = true;
  //   }

  //   if (!isDataChanged && imageFile instanceof File) {
  //     isDataChanged = true;
  //   }

  //   if (!isDataChanged) {
  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //     if (trigger) {
  //       closeEditModal();
  //     }
  //     return true;
  //   }
  //   setBtnLoading(true);
  //   try {
  //     if (!checkNetwork()) return;
  //     // var data = {
  //     //   // productid: updatedData._id,
  //     //   code: updatedData.code,
  //     //   hsnsac: updatedData.hsnsac,
  //     //   title: updatedData.title,
  //     //   mrp: CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
  //     //   saleprice: CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
  //     //   taxpercentage: updatedData.taxpercentage,
  //     //   // discount: CurrencyConverter.toSubunit(updatedData.discount, "INR"),
  //     //   baseprice: CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
  //     //   // taxamount: CurrencyConverter.toSubunit(updatedData.taxamount, "INR"),
  //     //   isLock: updatedData.isLock,
  //     //   landingcost: CurrencyConverter.toSubunit(
  //     //     updatedData.landingcost,
  //     //     "INR"
  //     //   ),
  //     //   note:updatedData.note,
  //     // };

  //     const formData = new FormData();
  //     formData.append("code", updatedData.code);
  //     formData.append("hsnsac", updatedData.hsnsac ?? "");
  //     formData.append("title", updatedData.title);
  //     formData.append(
  //       "mrp",
  //       CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
  //     );
  //     formData.append(
  //       "saleprice",
  //       CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
  //     );
  //     formData.append("taxpercentage", updatedData.taxpercentage);

  //     formData.append(
  //       "baseprice",
  //       CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
  //     );
  //     formData.append("isLock", updatedData.isLock);
  //     formData.append(
  //       "landingcost",
  //       CurrencyConverter.toSubunit(updatedData.landingcost || 0, "INR"),
  //     );

  //     formData.append(
  //       "searchTag", updatedData?.searchTag ??" ")
  //     formData.append("note", updatedData.note);
  //     if(updatedData?.brandData?.title){
  //       formData.append("brandId",updatedData?.brandData?.title)}
  //     if(updatedData?.unitConfig && !updatedData?.unitLocked){
  //       formData.append("unitConfig",JSON.stringify(updatedData?.unitConfig))}

  //     //  Append file only if it exists
  //     if (imageFile instanceof File) {
  //       formData.append("primaryImage", imageFile);
  //     } else {
  //       console.log("No image selected or wrong data type:", imageFile);
  //     }
  //     const response = await AxiosInstance.patch(
  //       `module/product/update-product/${updatedData._id}`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       },
  //     );
  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //     setProductData((prevProductData) =>
  //       prevProductData.map((product) =>
  //         product._id === response.data.results?._id
  //           ? {
  //               ...response.data.results,
  //               totalStockLeft: updatedData?.totalStockLeft,
  //             }
  //           : product,
  //       ),
  //     );
  //     if (trigger) {
  //       closeEditModal();
  //     }
  //     return true;
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  const hadlEditStockData = (updatedData, stockData, quantity) => {
    const totalStock =
      stockData?.reduce((total, item) => total + (item?.stockLeft || 0), 0) ??
      0;
    setProductData((prevProductData) =>
      prevProductData.map((product) =>
        product?._id === updatedData?.productid
          ? {
              ...product,
              totalStockLeft:
                totalStock +
                Number(
                  updatedData?.stockLinkInfo?.isSecondaryUnit
                    ? primaryQuanity(
                        quantity,
                        updatedData?.stockLinkInfo?.unitConfig,
                      )
                    : quantity,
                ),
            }
          : product,
      ),
    );
  };

  const hadlTrashStockData = (updatedData, stockData, quantity) => {
    const totalStock =
      stockData?.reduce((total, item) => total + (item?.stockLeft || 0), 0) ??
      0;
    setProductData((prevProductData) =>
      prevProductData.map((product) =>
        product?._id === updatedData?.productid
          ? {
              ...product,
              totalStockLeft:
                totalStock -
                Number(
                  updatedData?.stockLinkInfo?.isSecondaryUnit
                    ? primaryQuanity(
                        quantity,
                        updatedData?.stockLinkInfo?.unitConfig,
                      )
                    : quantity,
                ),
            }
          : product,
      ),
    );
  };
  const openDeleteModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async () => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = { productid: isDeleteData._id };
      await AxiosInstance.delete(
        `module/product/delete-product/${isDeleteData._id}`,
      );
      showAlert("success", Messages.SUCCESS.PRODUCT_DELETED);

      const newTotal = totalItems - 1;
      const newTotalPages = Math.ceil(newTotal / selectedFilter);

      if (isProductData.length === 1 && currentPage > 0) {
        setCurrentPage((prev) => prev - 1);
        await handleListProduct(currentPage - 1, isSearchTerm, selectedFilter);
      } else {
        await handleListProduct(currentPage, isSearchTerm, selectedFilter);
      }

      setTotalItems(newTotal);
      setTotalPages(newTotalPages);
      setDeleteModalOpen(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDeteleDataUpdate = async () => {
    const newTotal = totalItems - 1;
    const newTotalPages = Math.ceil(newTotal / selectedFilter);
    if (isProductData.length === 1 && currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
      await handleListProduct(currentPage - 1, isSearchTerm, selectedFilter);
    } else {
      await handleListProduct(currentPage, isSearchTerm, selectedFilter);
    }

    setTotalItems(newTotal);
    setTotalPages(newTotalPages);
    setDeleteModalOpen(false);
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "inactive":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  const handleLink = () => {
    if (hasPermission("PRODUCT", "PRODUCT:add") || permission === undefined) {
      const navigatelist = "/allproduct";
      navigate("/product", { state: { navigatelist } });
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleBulkProduct = () => {
    const navigatelist = "/allproduct";
    navigate("/product-upload", { state: { navigatelist } });
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const exportToCSV = async () => {
    try {
      if (!totalItems) {
        showAlert("warning", "No data available to export");
        return;
      }

      if (!checkNetwork()) return;

      setBtnCSVLoading(true);

      // Fetch ALL products, not only the current page
      const response = await AxiosInstance.get(
        `module/product/all?pageno=1&limit=${totalItems}&searchtxt=${encodeURIComponent(
          isSearchTerm || "",
        )}&sortby=a-z`,
      );

      const products = response.data?.results || [];

      if (!products.length) {
        showAlert("warning", "No data available to export");
        return;
      }

      const headers =
        `Name,Code,HSN,Tax(%),MRP,Sale Price,Wholesale Price,Base Price,` +
        `Price Lock,LandingCost,Unit,Secondary Unit,Conversion,Brand,Group,` +
        `Short Name,Search Tag,Min Stock Alert,Note,Opening Qty,Opening Cost,Batch No`;

      const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

      const rows = products
        .map((item) => {
          const row = [
            clean(item.title),
            clean(item.code),
            clean(item.hsnsac),
            clean(item.taxpercentage),
            clean(CurrencyConverter.toCurrency(item.mrp || 0, "INR")),
            clean(CurrencyConverter.toCurrency(item.saleprice || 0, "INR")),
            clean(
              CurrencyConverter.toCurrency(item?.wholesaleprice || 0, "INR"),
            ),
            clean(CurrencyConverter.toCurrency(item.baseprice || 0, "INR")),
            clean(item.isLock),
            clean(CurrencyConverter.toCurrency(item.landingcost || 0, "INR")),
            clean(item?.unitConfig?.primaryUnitCode),
            clean(item?.unitConfig?.secondaryUnitCode),
            clean(item?.unitConfig?.conversion),
            clean(item?.brandId),
            clean(item?.groupId),
            clean(item?.shortName),
            clean(item?.searchTag),
            clean(CurrencyConverter.toCurrency(item?.minimumStock || 0, "INR")),
            clean(item?.note),
            clean(CurrencyConverter.toCurrency(item?.openingStock || 0, "INR")),
            clean(CurrencyConverter.toCurrency(item?.openingCost || 0, "INR")),
            clean(item?.batchNo),
          ];

          return row.join(",");
        })
        .join("\n");

      const csvContent = [headers, rows].join("\n");

      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `ProductList_${formatDate(new Date())}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnCSVLoading(false);
    }
  };

  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && ProductSuggestions[activeIndex]) {
        e.preventDefault();
        handleSelectProduct(ProductSuggestions[activeIndex]);
      } else {
        e.preventDefault();
        handleSearchFind();
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < ProductSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : ProductSuggestions.length - 1,
      );
    }
  };

  useKeyboardTableNavigation({
    isActive,
    containerRef,
    searchTerms: isSearchTerm,
    suggestions: ProductSuggestions,
    modals: {
      isEditModalOpen,
      isDeleteModalOpen,
      globelPopupOpen,
      productViewOpen,
      showBarcodeModal,
    },
    onEnter: handleOpenProductView,
  });

  const handleFilterChange = (e) => {
    const values = e.target.value;
    setSelectedFilter(values);
  };

  const handleBrandSuggest = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/brand/suggestion`,
      );
      const result = response?.data?.results;
      setBrandSuggest(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };
  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (!isActive) return;
    if (
      showBarcodeModal ||
      productViewOpen ||
      isDeleteModalOpen ||
      isEditModalOpen
    )
      return;
    // small timeout ensures DOM is visible after tab switch
    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [
    isActive,
    showBarcodeModal,
    productViewOpen,
    isDeleteModalOpen,
    isEditModalOpen,
  ]);

  useEffect(() => {
    if (hasPermission("PRODUCT", "PRODUCT:list") || permission === undefined) {
      handleListProduct(currentPage, isSearchTerm, selectedFilter);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  }, [currentPage]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestNote();
    handleBrandSuggest();
  }, []);

  useEffect(() => {
    handleListProduct(currentPage, "", selectedFilter);
  }, [selectedFilter]);

  const handleRefresh = async () => {
    handleListProduct(currentPage, "", selectedFilter);
    setSelectedProductCode("");
    setSearchTerm("");
  };
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="row">
          <div className="col-12">
            <div className="page-breadcrumb  d-flex align-items-center paddingBottom">
              <div className="d-flex align-items-center pe-3">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isLoading ? "bx-spin" : ""}`} />
                  </button>
                </div>
                <span className="breadcrumb-title">All&nbsp;Product</span>
                <div className=" col-lg-12 ms-3">
                  <div className="position-relative">
                    <div className="input-group" ref={ProductSuggestionsRef}>
                      <input
                        type="text"
                        className="form-control"
                        ref={searchInputRef}
                        value={selectedProductCode}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                          setSelectedProductCode(e.target.value);
                          setActiveIndex(-1);
                        }}
                        onKeyDown={handleSuggestionNavigation}
                        autoComplete="off"
                        placeholder="Search product by name, code, email..."
                      />
                      {selectedProductCode ? (
                        <span
                          className="input-group-text"
                          onClick={() => {
                            setSelectedProductCode("");
                            handleListProduct();
                            setSearchTerm("");
                          }}
                        >
                          <XIcon />
                        </span>
                      ) : (
                        <button
                          className="input-group-text"
                          onClick={handleSearchFind}
                        >
                          <SearchIcon />
                        </button>
                      )}
                    </div>

                    {hasSearched &&
                      isSearchTerm &&
                      !suggestionLoading &&
                      ProductSuggestions.length === 0 && (
                        <ul className="suggestions-list">
                          <li className="suggestion-item text-muted">
                            No products data was found
                          </li>
                        </ul>
                      )}

                    {ProductSuggestions.length > 0 && (
                      <ProductSearchList
                        suggest={ProductSuggestions}
                        suggestionRefs={suggestionRefs}
                        handleSelect={handleSelectProduct}
                        activeIndex={activeIndex}
                      />
                      // <ul className="suggestions-list">
                      //   {ProductSuggestions.map((product, index) => (
                      //     <li
                      //       key={product._id}
                      //       ref={(el) => (suggestionRefs.current[index] = el)}
                      //       onClick={() => handleSelectProduct(product)}
                      //       className={`suggestion-item ${
                      //         index === activeIndex ? "active-suggestion" : ""
                      //       }`}
                      //     >
                      //       <span className="badge rounded-pill bg-label-navy">
                      //         {product.code}
                      //       </span>{" "}
                      //       {product.hsnsac &&(
                      //         <>
                      //       -
                      //       <span className="badge rounded-pill bg-label-retro">
                      //         {product.hsnsac}
                      //       </span>{" "}</>)}
                      //       -{product.title} -
                      //       <span className="badge bg-label-fall rounded-pill">
                      //         ₹
                      //         {CurrencyConverter.toCurrency(
                      //           product.saleprice || 0,
                      //           "INR",
                      //         )}
                      //       </span>
                      //       {product?.totalStockLeft &&(
                      //         <>
                      //         {"-"}
                      //       <span className="badge bg-label-space">
                      //         {product?.totalStockLeft}
                      //       </span>
                      //       </>)}
                      //     </li>
                      //   ))}
                      // </ul>
                    )}
                  </div>
                </div>
              </div>
              <div className="ms-auto d-flex gap-2">
                {uRLs.PRODUCT_BULK_UPLOAD === "true" && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleBulkProduct}
                    >
                      <UploadIcon /> Bulk Upload
                    </button>
                  </div>
                )}
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-export dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isBtnCSVLoading}
                  >
                    {isBtnCSVLoading ? (
                      <>
                        <CircularProgress size={16} className="me-1" />
                        Exporting...
                      </>
                    ) : (
                      <>
                        <DownloadIcon /> Export
                      </>
                    )}
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={exportToCSV}
                        disabled={isBtnCSVLoading}
                      >
                        {isBtnCSVLoading ? (
                          <>
                            <CircularProgress size={16} className="me-1" />
                            Preparing CSV...
                          </>
                        ) : (
                          <>
                            <SpreadSheetIcon />
                            <span className="icon-text">Excel (CSV)</span>
                          </>
                        )}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0">
                <div className="row px-3">
                  {/* <div className=" col-lg-4 col-12 ">
                    <div className="position-relative">
                      <div className="input-group" ref={ProductSuggestionsRef}>
                        <input
                          type="text"
                          className="form-control"
                          ref={searchInputRef}
                          onChange={(e) => {
                            handleSearch(e.target.value);
                            setActiveIndex(-1);
                          }}
                          onKeyDown={handleSuggestionNavigation}
                          autoComplete="off"
                          placeholder="Search product by name, code, email..."
                        />
                        <button
                          className="input-group-text"
                          onClick={handleSearchFind}
                        >
                          <i className="bx bx-search"></i>
                        </button>
                      </div>

                      {hasSearched &&
                        isSearchTerm &&
                        !suggestionLoading &&
                        ProductSuggestions.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No products data was found
                            </li>
                          </ul>
                        )}

                      {ProductSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {ProductSuggestions.map((product, index) => (
                            <li
                              key={product._id}
                              ref={(el) => (suggestionRefs.current[index] = el)}
                              onClick={() => handleSelectProduct(product)}
                              className={`suggestion-item ${
                                index === activeIndex ? "active-suggestion" : ""
                              }`}
                            >
                              <span className="badge rounded-pill bg-label-navy">
                                {product.code}
                              </span>{" "}
                              -
                              <span className="badge rounded-pill bg-label-retro">
                                {product.hsnsac}
                              </span>{" "}
                              -{product.title} -
                              <span className="badge bg-label-fall rounded-pill">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  product.saleprice || 0,
                                  "INR"
                                )}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div> */}
                  <div className="col-lg-2 col-6 d-flex align-items-center">
                    <div>
                      <strong>Total Products:</strong>{" "}
                      <span className="badge btn-label-primary fs-15 ">
                        {totalItems || 0}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-3 col-12 mb-2 mb-lg-0">
                    <div className="input-group">
                      <span className="input-group-text">
                        <SortDownIcon />
                      </span>
                      <select
                        className="form-select"
                        onChange={handleFilterChange}
                        value={selectedFilter}
                      >
                        <option value={10}>10 Row Per page</option>
                        <option value={50}>50 Row per Page</option>
                        <option value={100}>100 Row per Page</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-7 col-6 d-flex justify-content-end ">
                    <button
                      type="button"
                      className="btn btn-primary mt-2 mt-lg-0"
                      onClick={handleLink}
                    >
                      <AddIcon /> Add Product
                    </button>
                  </div>
                </div>

                {/* <div className="table-responsive mt-3">
                  <table className="table align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th>S.No</th>
                        <th>SKU Code</th>
                        <th>Title</th>
                        <th>MRP</th>
                        <th>Discount</th>
                        <th>Sale Price</th>
                        <th>Tax(%)</th>
                        <th>LandingCost</th>
                        <th>Stock Left</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        [...Array(10)].map((_, index) => (
                          <tr key={index}>
                            {[...Array(11)].map((__, i) => (
                              <td key={i} className="text-center">
                                <Skeleton
                                  variant="text"
                                  width={i === 0 ? 50 : 120}
                                />
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : isProductData.length > 0 ? (
                        isProductData.map((item, index) => (
                          <tr
                            key={item._id || index}
                            className="position-relative  cursor-poInter hover-row"
                            onClick={() => handleOpenProductView(item)}
                            data-item={JSON.stringify(item)}
                          >
                            <td className="text-center">
                              {currentPage * selectedFilter + index + 1}
                            </td>
                            <td className="text-center">
                              <span className="badge rounded-pill bg-label-navy">
                                {item.code}
                              </span>
                            </td>
                            <td className="text-center">
                              <span className="text-heading fw-medium text-wrap">
                                {item.title}
                              </span>
                            </td>
                            <td className="text-center">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.mrp || 0,
                                "INR"
                              )}
                            </td>
                            <td className="text-center">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.discount || 0,
                                "INR"
                              )}
                            </td>
                            <td className="text-center fw-medium">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.saleprice || 0,
                                "INR"
                              )}
                            </td>
                            <td className="text-center">
                              <span className="badge rounded-pill bg-label-peace">
                                {item.taxpercentage
                                  ? `${item.taxpercentage}%`
                                  : "0%"}
                              </span>
                            </td>
                            <td className="text-center fw-medium">
                              ₹
                              {CurrencyConverter.toCurrency(
                                item.landingcost || 0,
                                "INR"
                              )}
                            </td>
                            <td className="text-center">
                              {item?.totalStockLeft ? (
                                <span className="badge bg-label-space">
                                  {item?.totalStockLeft}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center">
                              {item.status && (
                                <span
                                  className={`badge rounded-pill ${getColor(
                                    item.status
                                  )}`}
                                >
                                  {item.status.charAt(0).toUpperCase() +
                                    item.status.slice(1).toLowerCase()}
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="order-actions opacity-0 opacity-md-100">
                                <button
                                  type="button"
                                  className="btn-label-primary shadow-none me-2"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openEditModal(item);
                                  }}
                                >
                                  <i className="ng ng-ng-edit-icon"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn-label-danger shadow-none me-2"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openDeleteModal(item);
                                  }}
                                >
                                  <i className="ng ng-ng-delete-icon"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="10"
                            className="text-center p-2 text-muted"
                          >
                            <span className="text-muted">
                              No products found in the store. add some products
                              to get started.
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div> */}
                <div ref={containerRef}>
                  <Table
                    loading={isLoading}
                    data={isProductData}
                    onRowClick={(item) => handleOpenProductView(item)}
                    columns={[
                      {
                        label: "S.No",
                        render: (_, index) => (
                          <>{currentPage * selectedFilter + index + 1}</>
                        ),
                      },
                      {
                        label: "SKU Code",
                        render: (item) => (
                          <span className="badge rounded-pill bg-label-navy">
                            {item.code}
                          </span>
                        ),
                      },
                      {
                        label: "Title",
                        tdBodyclass: "text-align-left-force",
                        render: (item) => (
                          <span className="text-heading fw-medium text-wrap">
                            {item.title}
                          </span>
                        ),
                      },
                      {
                        label: "MRP",
                        render: (item) => (
                          <span className="fw-medium text-right">
                            {formatCurrencyFun(item?.mrp)}
                          </span>
                        ),
                      },
                      {
                        label: "Discount",
                        render: (item) => (
                          <span className="fw-medium text-right">
                            {formatCurrencyFun(item?.discount)}
                          </span>
                        ),
                      },
                      {
                        label: "Sale Price",
                        render: (item) => (
                          <span className="fw-medium text-right p-2">
                            {formatCurrencyFun(item?.saleprice)}
                          </span>
                        ),
                      },
                      {
                        label: "Tax(%)",
                        render: (item) => (
                          <span className="badge rounded-pill bg-label-peace">
                            {item.taxpercentage
                              ? `${item.taxpercentage}%`
                              : "0%"}
                          </span>
                        ),
                      },
                      {
                        label: "LandingCost",
                        render: (item) => (
                          <span className="fw-medium text-right">
                            {formatCurrencyFun(item?.landingcost)}
                          </span>
                        ),
                      },
                      // {
                      //   label: "Unit",
                      //   render: (item) => (
                      //     <span className="badge btn-unit">
                      //       {item?.unitConfig?.primaryUnitCode==="unit"?"": item?.unitConfig?.primaryUnitCode}
                      //     </span>
                      //   ),
                      // },
                      {
                        label: "Stock Left",
                        render: (item) => (
                          <>
                            {item?.totalStockLeft ? (
                              <span className="badge bg-label-space">
                                {item?.totalStockLeft}
                                <span className="font-11 ms-1">
                                  {/* {item?.unitConfig?.primaryUnitCode === "unit"
                                    ? ""
                                    : item?.unitConfig?.primaryUnitCode} */}
                                  {item?.unitConfig?.primaryUnitCode}
                                </span>
                              </span>
                            ) : (
                              "-"
                            )}
                          </>
                        ),
                      },
                      {
                        label: "Status",
                        thClass: "w-12",
                        render: (item) => (
                          <>
                            <div className="no-print position-relative">
                              <div className=" d-flex justify-content-center align-items-center">
                                {item.status && (
                                  <span
                                    className={`stock-status-badge badge rounded-pill ${getColor(
                                      item.status,
                                    )}`}
                                  >
                                    {item.status.charAt(0).toUpperCase() +
                                      item.status.slice(1).toLowerCase()}
                                  </span>
                                )}
                                <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                  <button
                                    type="button"
                                    className="btn-label-primary shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openEditModal(item);
                                    }}
                                  >
                                    <EditIcon />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-label-primary shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickBarcode(item);
                                    }}
                                  >
                                    <BarcodeIcon />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-label-danger shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openDeleteModal(item);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ),
                      },
                      // {
                      //   label: "Actions",
                      //   render: (item) => (
                      //     <div className="order-actions opacity-0 opacity-md-100">
                      //       <button
                      //         type="button"
                      //         className="btn-label-primary shadow-none me-2"
                      //         onClick={(e) => {
                      //           e.stopPropagation();
                      //           openEditModal(item);
                      //         }}
                      //       >
                      //         <i className="ng ng-ng-edit-icon"></i>
                      //       </button>
                      //       <button
                      //         type="button"
                      //         className="btn-label-primary shadow-none me-2"
                      //         onClick={(e) => {
                      //           e.stopPropagation();
                      //           handleClickBarcode(item);
                      //         }}
                      //       >
                      //         <i className="bx bx-barcode"></i>
                      //       </button>
                      //       <button
                      //         type="button"
                      //         className="btn-label-danger shadow-none me-2"
                      //         onClick={(e) => {
                      //           e.stopPropagation();
                      //           openDeleteModal(item);
                      //         }}
                      //       >
                      //         <i className="ng ng-ng-delete-icon"></i>
                      //       </button>
                      //     </div>
                      //   ),
                      // },
                    ].filter(Boolean)}
                  />
                </div>
                {totalPages > 0 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      previousLabel={"← Previous"}
                      nextLabel={"Next →"}
                      breakLabel={"..."}
                      onPageChange={({ selected }) => {
                        setIsLoading(true);
                        setCurrentPage(selected);
                      }}
                      pageRangeDisplayed={5}
                      pageCount={totalPages}
                      containerClassName="pagination"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {isEditModalOpen && (
          <EditProduct
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdte}
            isBtnLoading={isBtnLoading}
            noteSuggests={noteSuggest}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteModal
            onClose={() => setDeleteModalOpen(false)}
            onConfirm={handleDelete}
            isLable={" Product " + isDeleteData?.title}
            isBtnLoading={isBtnLoading}
          />
        )}
        {productViewOpen && (
          <ProductOverView
            onClose={handleCloseProductView}
            onData={productData}
            onStockData={productStockData}
            onUpdate={handleUpdte}
            noteSuggests={noteSuggest}
            isBtnLoading={isBtnLoading}
            setProductData={setProductData}
            onStockEditData={hadlEditStockData}
            OnStockTrashData={hadlTrashStockData}
            handleDeteleDataUpdate={handleDeteleDataUpdate}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}
        {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
          <BarcodeGenerator
            barcodeValue={selectedBarcode.code}
            product={selectedBarcode}
            onClose={() => setShowBarcodeModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AllListProduct;
